require("!!C:\\Users\\bompadre\\Documents\\angular2\\myapp2\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\bompadre\\Documents\\angular2\\myapp2\\node_modules\\raw-loader\\index.js!C:\\Users\\bompadre\\Documents\\angular2\\myapp2\\node_modules\\chart.js\\dist\\chart.js"))


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/node_modules/script-loader!C:/Users/bompadre/Documents/angular2/myapp2/node_modules/chart.js/dist/chart.js
// module id = ../../../../script-loader/index.js!../../../../chart.js/dist/chart.js
// module chunks = scripts